import React from "react";
import SendIcon from "../../../../assets/svgs/send_icon.svg";
import CloseIcon from '@mui/icons-material/Close';
import { chatInputFieldStyle as styles } from "./chatInputFieldStyle.tailwind";
import TextArea from "../../Input/TextArea/TextArea";
import { Modal } from "@mui/material";

const ChatInputFieldModal = ({ isOpen, inputValue, handleSendMessage, onChange, rows, onKeyDown, onClose }) => {

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            disableAutoFocus
        >
            <div className={styles.container}>
                <button onClick={onClose} className={styles.closeIcon}>
                    <CloseIcon sx={{ fontSize: "18px" }} />
                </button>

                {/* Input Field */}
                <div className="flex gap-1 items-center w-full relative">
                    <h1 className="absolute top-[-14px] left-4 text-[12px]">Enter message</h1>
                    <TextArea
                        type="text"
                        autoFocus
                        value={inputValue}
                        onChange={onChange}
                        onKeyDown={onKeyDown}
                        placeholder="Type a message"
                        rows={rows}
                        className={"p-3 rounded-[8px] text-[18px]"}
                    />

                    {/* Send Button */}
                    <button onClick={handleSendMessage} className={styles.sendButton}>
                        <img src={SendIcon} alt="Send" className="w-6 h-6" />
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ChatInputFieldModal;
